import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail, MessageCircle, HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const LOGO_URL = "/logo.png";

const SupportPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <Button onClick={() => navigate('/')} variant="ghost" className="text-white hover:bg-white/20">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
          <img src={LOGO_URL} alt="My Wishlists" className="h-12" />
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-6">Support & Help Center</h1>
          
          <div className="space-y-8">
            {/* Contact Information */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                <MessageCircle className="w-6 h-6 text-purple-600" />
                Contact Us
              </h2>
              <p className="text-gray-600 mb-4">
                We&apos;re here to help! Reach out to us through any of the following channels:
              </p>
              <div className="space-y-3">
                <div className="flex items-center gap-3 p-4 bg-purple-50 rounded-lg">
                  <Mail className="w-5 h-5 text-purple-600" />
                  <div>
                    <p className="font-semibold text-gray-800">Email Support</p>
                    <a href="mailto:support@mywishlists.in" className="text-purple-600 hover:underline">
                      support@mywishlists.in
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* FAQs Section */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                <HelpCircle className="w-6 h-6 text-purple-600" />
                Frequently Asked Questions
              </h2>
              <div className="space-y-4">
                <div className="border-l-4 border-purple-600 pl-4">
                  <h3 className="font-semibold text-gray-800 mb-2">How do I create a wishlist?</h3>
                  <p className="text-gray-600">After logging in, go to your Dashboard and click &quot;Create Wishlist&quot;. Add items by pasting product URLs from e-commerce sites like Amazon, Myntra, or Nykaa.</p>
                </div>
                <div className="border-l-4 border-purple-600 pl-4">
                  <h3 className="font-semibold text-gray-800 mb-2">Can I share my wishlist with others?</h3>
                  <p className="text-gray-600">Yes! You can share your wishlist via WhatsApp or add collaborators who can help manage it.</p>
                </div>
                <div className="border-l-4 border-purple-600 pl-4">
                  <h3 className="font-semibold text-gray-800 mb-2">How does the surprise element work?</h3>
                  <p className="text-gray-600">When someone selects a gift from your wishlist, you&apos;ll see it&apos;s been &quot;Reserved by a loved one&quot; without knowing who selected it. This keeps the surprise intact!</p>
                </div>
                <div className="border-l-4 border-purple-600 pl-4">
                  <h3 className="font-semibold text-gray-800 mb-2">Is my data secure?</h3>
                  <p className="text-gray-600">Absolutely! We use industry-standard encryption and follow best practices to keep your data safe. Read our <button onClick={() => navigate('/privacy')} className="text-purple-600 hover:underline font-semibold">Privacy Policy</button> for more details.</p>
                </div>
                <div className="border-l-4 border-purple-600 pl-4">
                  <h3 className="font-semibold text-gray-800 mb-2">Can I use this for any type of event?</h3>
                  <p className="text-gray-600">Yes! My Wishlists works for birthdays, anniversaries, baby showers, weddings, housewarmings, and any celebration where gifts are involved.</p>
                </div>
              </div>
            </section>

            {/* Response Time */}
            <section className="bg-purple-50 p-6 rounded-lg">
              <h2 className="text-xl font-semibold text-gray-800 mb-3">Response Time</h2>
              <p className="text-gray-600">
                We strive to respond to all support queries within 24-48 hours during business days. For urgent issues, please call our phone support line.
              </p>
            </section>

            {/* More Help */}
            <section>
              <p className="text-gray-600">
                For more detailed information, visit our <button onClick={() => navigate('/faqs')} className="text-purple-600 hover:underline font-semibold">FAQs page</button>.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportPage;
